import { render, staticRenderFns } from "./DemoSnackbarMultiline.vue?vue&type=template&id=339f2ac6&"
import script from "./DemoSnackbarMultiline.vue?vue&type=script&lang=js&"
export * from "./DemoSnackbarMultiline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../landing-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../landing-app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VSnackbar})
